import { Fragment, useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../Context/GlobalContext";
import { isValidArray, normalizePath, showMyWalletClick } from "../../../../Layout/Common/common";

import { Link } from "react-router-dom";
import { CardIcon } from "../../../../Layout/Common/CardIcon";
import { PAGES } from "../../../../routeConfig";
import { useAuth } from "../../../../Context/AuthContext";
import { useLoginModal } from "../../../../Context/LoginModalContext";
import { takePendingCardUuid } from "../../../../Context/hook/tillRedirect";

export const MyWalletPayment = ({ handleOnCheck, defaultCheck, TotalAmount, orderId, wallet }) => {
  const { storedCard, selectedCard, setSelectedCard, selectedPaymentType } = useContext(GlobalContext);
  const { isAuthenticated } = useAuth();
  const { showLoginModal } = useLoginModal();

  useEffect(() => {
    if (storedCard) {
      console.log("storedCard", storedCard);
      if (!selectedCard) {
        var restoredUuid = takePendingCardUuid();
        var restoredCard = restoredUuid
          ? storedCard.find((item) => item.IsExpired == false && item.cardUuid == restoredUuid)
          : null;
        var defaultCard = restoredCard || storedCard.find((item) => item.IsExpired == false && item.isdefault == true);
        if (defaultCard) {
          setSelectedCard(defaultCard);
        } else {
          setSelectedCard(null);
        }
      }
    }
  }, [storedCard]);

  const getCardType = (ctype) => {
    let cardType = normalizePath(ctype);
    if (cardType == "mastercard" || cardType.includes("master")) return "master";
    if (cardType == "visacard" || cardType.includes("visa")) return "visa";
    if (cardType == "amex" || cardType.includes("amex")) return "amex";
    return "cards";
  };

  return (
    <Fragment>
      {isValidArray(storedCard) &&
        storedCard.map((item, index) => {
          if (item.IsExpired === false) {
            return (
              <div className="payment-card-list shipPayment">
                <div className="shipping-method savedCards-details">
                  <div className="shipping-method-info pay-option" data-group={index} data-type="wallet">
                    <div>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="saved-cards"
                        id={"savecard" + index}
                        onChange={(e) => {
                          setSelectedCard(item);
                          handleOnCheck("MYWALLET");
                        }}
                        value="MYWALLET"
                        checked={
                          selectedPaymentType == "MYWALLET" && selectedCard && item.cardUuid == selectedCard.cardUuid
                        }
                        disabled={item.IsExpired}
                      />
                    </div>
                    <label className="form-check-label" htmlFor={"savecard" + index}>
                      <div className="full-width d-flex align-items-center" style={{ gap: "10px", minWidth: "50px" }}>
                        <div className="pay-icon">
                          <CardIcon cardType={getCardType(item.cardType || item.card_type)} />
                        </div>
                        <div>
                          <span>
                            Card Ending in <b>*{item.cardNo}</b>
                            <span className="savedCard-exp">
                              {" "}
                              Expiry: <b>{item.cardExp}</b> {String(item.cardName).slice(0, 18)}
                            </span>
                          </span>
                          {item.IsExpired && (
                            <div className="card-exp-message">
                              <p>
                                <b style={{ color: "red" }}>Card Expiry Date has past. </b>
                                <Link to={PAGES.MYWALLET}>Please update card.</Link>
                              </p>
                            </div>
                          )}
                        </div>
                      </div>
                    </label>
                  </div>
                </div>
              </div>
            );
          }
        })}
      {!isAuthenticated && Number(wallet) > 0 ? (
        <div
          className="choose-card payment-card-list shipPayment"
          onClick={() => showLoginModal()}
        >
          <div className="shipping-method express-shipping">
            <div className="shipping-method-info pay-option" data-group={1} data-type="card" id="pay-card">
              <div>
                <input
                  className="form-check-input"
                  type="radio"
                  name="paymentMethod"
                  id="wallertCardPayment"
                  value="MYWALLET"
                  onChange={() => {
                    handleOnCheck("MYWALLET");
                  }}
                  onClick={() => {
                    handleOnCheck("MYWALLET");
                  }}
                  checked={selectedPaymentType == "MYWALLET"}
                />
              </div>
              <label className="form-check-label" htmlFor="wallertCardPayment">
                My Wallet
              </label>
            </div>
            <p>
              <CardIcon cardType="cards" alt="card payment" />
            </p>
          </div>
        </div>
      ) : (
        <></>
      )}
    </Fragment>
  );
};
